/**
 * Chuỗi của màn sử dụng ai thuộc Nhật ký & Truy vết (module `audit`, ADR-0095) — tách tệp khi dựng song song như
 * `tro-ly-ai/`, sẽ gộp vào `vi.ts`. Khoá cấp một mang tiền tố `nktvSuDungAi`; sâu tối đa hai cấp dưới nó.
 *
 * Port `nhatKy.suDungAi`, `nhatKy.vet` và phần AI của `nhatKy.thongKe` (web-portal native). Nhãn, trạng thái, bảy loại
 * token (`nktv.loaiToken`) và dải chất lượng số liệu dùng chung đã ở `chung.vi.ts`.
 */
export const viNktvSuDungAi = {
  nktvSuDungAi: {
    tieuDe: 'Nhật ký sử dụng AI',
    cotTenant: 'Tenant',
    cotGiaVon: 'Giá vốn',
    tatCaTenant: 'Mọi tenant',
    tab: {
      tongQuan: 'Tổng quan',
      trace: 'Theo chuỗi xử lý',
      luotGoi: 'Từng lượt gọi mô hình',
      luong: 'Theo đối tượng',
    },
    loc: {
      moHinh: 'Mô hình',
      nhaCungCap: 'Nhà cung cấp',
      service: 'Dịch vụ',
      tinhNang: 'Tính năng',
      nguoiDung: 'Người dùng',
      donVi: 'Đơn vị',
      trangThai: 'Trạng thái giá vốn',
      trangThaiDaTinh: 'Đã tính giá vốn',
      trangThaiChuaCoGia: 'Chưa có giá vốn',
      coCanhBao: 'Cảnh báo token',
      coCanhBaoCo: 'Có cảnh báo',
      coCanhBaoKhong: 'Không cảnh báo',
      loiGoiY: 'Chưa tải được danh sách gợi ý cho bộ lọc — ô lọc có thể thiếu giá trị.',
    },
    danhSach: {
      sapXep: 'Sắp xếp',
      moiNhat: 'Mới nhất',
      tonNhat: 'Nhiều token nhất',
      xepHangMotTrang:
        'Chế độ "Nhiều token nhất" là bảng xếp hạng chỉ có một trang — không tải thêm được. Để xem toàn bộ dữ liệu, chuyển về "Mới nhất".',
      het: 'Đã hiển thị toàn bộ {{so}} dòng khớp bộ lọc này.',
      rongLoc: 'Không có dòng nào khớp bộ lọc',
    },
    trace: {
      bang: 'Danh sách chuỗi xử lý',
      goiY: 'Mỗi dòng là một chuỗi xử lý: một câu hỏi, một lượt quét chứng từ. Bấm vào dòng để xem từng bước.',
      cotBatDau: 'Bắt đầu',
      cotChuoi: 'Chuỗi xử lý',
      cotNguoi: 'Người thực hiện',
      cotService: 'Dịch vụ',
      cotBuoc: 'Bước',
      cotMoHinh: 'Mô hình',
      cotTietKiem: 'Tiết kiệm nhờ bộ nhớ đệm',
      cotKeoDai: 'Thời lượng',
      cotMo: 'Mở',
      soLoi: '{{so}} lỗi',
      hoiChatbot: 'Hỏi chatbot {{ten}}',
      tieuDeCoAi: 'Chuỗi xử lý có {{so}} lượt gọi AI',
      maTraCuuNgan: 'Mã tra cứu {{ma}}…',
      moChuoi: 'Mở chuỗi xử lý để xem từng bước',
      rongTieuDe: 'Không có chuỗi xử lý nào',
      rongMoTa: 'Không có chuỗi nào trong khoảng thời gian này. Thử mở rộng khoảng thời gian ở phần trên.',
      cotLuotAi: 'Lượt AI',
      cotLoi: 'Lỗi',
      cotTinCay: 'Độ tin cậy',
    },
    luotGoi: {
      bang: 'Danh sách lượt gọi mô hình',
      cotThoiGian: 'Thời gian',
      cotMoHinh: 'Mô hình',
      cotTinhNang: 'Tính năng',
      cotNguoi: 'Người / đối tượng',
      cotTietKiem: 'Tiết kiệm nhờ bộ nhớ đệm',
      cotDoTre: 'Độ trễ',
      cotTinCay: 'Độ tin cậy',
      cotChuoi: 'Chuỗi',
      xemChuoi: 'Xem chuỗi',
      rongTieuDe: 'Không có lượt gọi mô hình nào',
      rongMoTa: 'Không có lượt gọi nào trong khoảng thời gian này. Thử mở rộng khoảng thời gian ở phần trên.',
    },
    luong: {
      bang: 'Danh sách đối tượng nghiệp vụ theo token',
      cotDoiTuong: 'Đối tượng',
      cotKhoang: 'Từ → đến',
      cotNguoi: 'Số người',
      cotService: 'Dịch vụ',
      loai: 'Loại đối tượng',
      loaiTatCa: 'Tất cả',
      cacTrace: 'Các chuỗi xử lý của đối tượng này — bấm một mã để xem từng bước:',
      khongCoTrace: 'Bản ghi tổng hợp không kèm danh sách mã chuỗi.',
      motTrang:
        'Đã hiển thị {{so}} đối tượng, sắp xếp theo tổng token giảm dần. Đây là bảng xếp hạng một trang, không tải thêm.',
      rongTieuDe: 'Không có đối tượng nào',
      rongMoTa: 'Không có đối tượng nghiệp vụ nào được xử lý trong khoảng này. Thử mở rộng khoảng thời gian ở phần trên.',
      cotSoChuoi: 'Chuỗi',
    },
    chuoi: {
      tieuDe: 'Diễn tiến của một chuỗi xử lý',
      goiMoHinh: 'Gọi mô hình',
      luotGoiAi: 'Lượt gọi AI',
      batDauSau: 'bắt đầu sau {{lech}}',
      moChiTiet: 'Bấm để xem chi tiết bước này',
      goiYMo: 'Bấm vào một bước để xem chi tiết.',
      cotBuoc: 'Bước',
      luc: 'Thời điểm',
      nguoi: 'Người thực hiện',
      dichVu: 'Dịch vụ',
      doiTuong: 'Đối tượng',
      moHinh: 'Mô hình',
      tietKiem: 'Tiết kiệm nhờ bộ nhớ đệm',
      bocTach: 'Phân tích bảy loại token',
      maTraCuu: 'Mã tra cứu (trace_id)',
      keoDai: 'Thời lượng',
      soBuoc: 'Số bước',
      lech: 'Cách lúc bắt đầu {{lech}}',
      doTre: 'độ trễ {{doTre}}',
      khongKhaiDoTre: 'bước này không ghi nhận độ trễ',
      thanhToken: 'Token của bước: {{so}}',
      biCat:
        'Chuỗi dài hơn giới hạn 200 bước nên danh sách dưới đây đã được rút gọn — các bước cuối không hiển thị, và tổng token chỉ tính trên phần đã tải.',
      chuGiaiThuong: 'Bước nghiệp vụ',
      chuGiaiLlm: 'Lượt gọi mô hình',
      chuGiaiLoi: 'Bước thất bại',
      chuGiaiToken: 'Token của bước (so với bước nhiều token nhất)',
      chuGiaiVach: 'Vạch mảnh = bước không ghi nhận độ trễ, chỉ biết thời điểm.',
      rongTieuDe: 'Chuỗi không có bước nào',
      rongMoTa: 'Không có bản ghi nào mang mã tra cứu này trong phạm vi bạn được xem.',
      foxVao: 'Token Fox đầu vào',
      foxRa: 'Token Fox đầu ra',
      foxPhu: 'Vào {{vao}} · ra {{ra}}',
    },
    token: {
      thanhNhan: 'Tỷ lệ bảy loại token trong lượt gọi này',
      dau_vao: 'Đầu vào',
      dau_vao_anh: 'Đầu vào ảnh',
      dau_vao_tool: 'Đầu vào công cụ',
      dau_vao_dem: 'Đọc từ bộ nhớ đệm',
      ghi_dem: 'Ghi vào bộ nhớ đệm',
      dau_ra: 'Đầu ra',
      suy_luan: 'Suy luận',
      congBay: 'Cộng bảy loại:',
      tongBao: 'Tổng do hệ thống báo:',
      khongBao: 'Nhà cung cấp không báo loại này — khác với bằng 0.',
      soKhongBao: '{{so}} loại không được báo',
      lechPhanHoach:
        'Bảy loại cộng lại lệch {{lech}} token so với tổng đã ghi. Bảy loại phải cộng đúng bằng tổng, nên đây là lỗi của bộ chuẩn hoá token — không dùng dòng này để chốt số liệu.',
    },
    co: {
      chuaCoGia: 'Chưa có giá vốn',
      chuaCoGiaMoTa: 'Mô hình này chưa có trong bảng giá vốn nên giá vốn còn thiếu phần đó. Số token vẫn đúng.',
      khaiGia: 'Mở giá vốn model',
      khaiGiaMoTa: 'Mở giá vốn model để khai giá cho mô hình {{moHinh}}',
      thieuTyGia: 'Thiếu tỷ giá',
      thieuTyGiaMoTa: 'Mô hình đã có giá vốn nhưng chưa có tỷ giá cho ngày của lượt gọi, nên giá vốn còn để trống. Số token vẫn đúng.',
      xemTyGia: 'Xem tỷ giá',
      xemTyGiaMoTa: 'Mở giá vốn model, nơi nhập tỷ giá',
      canhBao: '{{so}} cảnh báo quy đổi',
      canhBaoMoTa:
        'Bộ chuẩn hoá token có cảnh báo về chính phép quy đổi token của lượt này, nên số liệu chưa đủ tin cậy để chốt. Việc cần làm: báo đội kỹ thuật sửa bộ chuẩn hoá token.',
      uocTinh: 'giá ước tính',
      uocTinhMoTa: 'Giá vốn tính theo giá ước tính, không phải giá đã khai báo.',
      khongDangTin: 'Chưa đủ tin cậy',
      khongDangTinMoTa:
        'Trong chuỗi có ít nhất một lượt gọi mang cảnh báo quy đổi token, nên tổng của chuỗi chưa dùng để chốt số liệu.',
      tietKiemAm:
        'Giá trị âm: đọc lại từ bộ nhớ đệm tốn hơn gọi mới. Đây là kết quả thật của phép tính, không phải lỗi hiển thị.',
    },
    tongQuan: {
      khongLuotTieuDe: 'Không có lượt gọi mô hình nào',
      khongLuotMoTa:
        'Kỳ đang chọn không có lượt gọi mô hình nào được ghi vết. Thử mở rộng khoảng thời gian, hoặc kiểm tra xem dịch vụ đang dùng đã gửi vết lượt gọi AI chưa.',
      soLuot: 'Lượt gọi mô hình',
      soLuotPhu: 'Thuộc {{trace}} chuỗi xử lý.',
      soMoHinh: 'Số mô hình',
      soMoHinhPhu: 'Có lượt gọi trong kỳ.',
      tokenFox: 'Token Fox',
      tokenFoxPhu: 'Đầu vào + đầu ra',
      foxVao: 'Token Fox đầu vào',
      foxRa: 'Token Fox đầu ra',
      tyLeTrenTong: '{{tyLe}} tổng token Fox',
      tokenThatPhu: 'Đủ bảy loại token.',
      giaVonPhu: 'Số tiền chốt lúc ghi.',
      giaVonChuaDu: '{{so}} lượt chưa có giá vốn.',
    },
    bieuDo: {
      tokenTieuDe: 'Token thật theo thời gian, tách bảy loại',
      tokenMoTa:
        'Bảy loại token không chồng lấn nhau: mỗi token thuộc đúng một loại, nên bảy phần cộng lại đúng bằng tổng token.',
      tokenNhan: 'Cột xếp chồng: token theo thời gian, tách theo bảy loại',
      tokenKhop: 'Bảy phần cộng lại được {{bay}} token, tổng do audit-service ghi nhận là {{tong}} — khớp.',
      tokenLech:
        'Bảy phần cộng lại được {{bay}} token nhưng tổng do audit-service ghi nhận là {{tong}}, và {{moc}} mốc thời gian bị lệch. Bảy loại token không còn cộng đúng bằng tổng: lỗi nằm ở bộ chuẩn hoá token, không phải ở biểu đồ. Xem cảnh báo của từng lượt ở tab Từng lượt gọi mô hình.',
      tongToken: 'Tổng token thật',
      soTokenThe: '{{so}} token',
      soLuot: 'Lượt',
      tietKiemThe: 'Tiết kiệm',
      tietKiemTieuDe: 'Tiết kiệm nhờ bộ nhớ đệm',
      tietKiemMoTa: 'Số tiền tiết kiệm được nhờ đọc lại từ bộ nhớ đệm, trừ đi số tiền đã trả để ghi bộ nhớ đệm.',
      tietKiemNhan: 'Cột: tiền tiết kiệm nhờ bộ nhớ đệm theo thời gian, có thể âm',
      tietKiemAm:
        'Số âm không phải là lỗi: tiền ghi bộ nhớ đệm đang lớn hơn tiền tiết kiệm được, tức đã trả tiền ghi nhưng chưa dùng lại đủ để bù. Giá trị âm được hiển thị đúng dấu, không điều chỉnh về 0.',
      tietKiemPhiLuu: 'Chưa gồm phí lưu bộ nhớ đệm theo giờ — khoản đó nằm ngoài công thức.',
      foxTieuDe: 'Token Fox theo thời gian',
      foxNhan: 'Cột xếp chồng: token Fox theo thời gian, tách đầu vào và đầu ra',
      foxTong: 'Tổng token Fox',
      giaVonTieuDe: 'Giá vốn theo thời gian',
      giaVonMoTa: 'Theo giá vốn có hiệu lực lúc ghi.',
      giaVonNhan: 'Cột: giá vốn theo thời gian',
      giaVonChuaDu: '{{so}} lượt trong kỳ chưa có giá vốn nên không được tính vào các cột này.',
    },
    dichVu: {
      audit: 'Nhật ký & Truy vết',
      baoCao: 'Báo cáo doanh nghiệp',
      ekyc: 'Định danh eKYC',
      index: 'Chỉ mục tri thức',
      ocr: 'Xử lý tài liệu',
      rpa: 'Quản lý RPA',
      soTayViec: 'Sổ tay việc',
      thamDinh: 'Thẩm định AI',
      triThuc: 'Tri thức AI',
      troLyAi: 'Trợ lý AI',
      vanBan: 'Xử lý văn bản',
    },
    tinhNang: {
      ocrQuet: 'Quét chứng từ (OCR)',
      ocrDocTrang: 'Đọc một trang chứng từ (OCR)',
      ocrDocTruoc: 'Đọc trước tài liệu (OCR)',
      ocrDeXuatSchema: 'Đề xuất cấu hình chứng từ (OCR)',
      troLySinhSql: 'Trợ lý số liệu · sinh SQL',
      troLySoanLoi: 'Trợ lý số liệu · soạn lời',
      troLyDocThanhTieng: 'Trợ lý số liệu · đọc thành tiếng',
      troLyTraWeb: 'Trợ lý số liệu · tra web',
      indexCauTruc: 'Dựng cấu trúc tài liệu',
      indexDocAnh: 'Đọc tài liệu scan',
      ekycBocTach: 'Bóc tách giấy tờ eKYC',
      thamDinhHoiDap: 'Hỏi đáp thẩm định',
      thamDinhDanhGia: 'Viết bản đánh giá thẩm định',
      thamDinhBanSua: 'Đề xuất bản sửa hồ sơ',
      thamDinhGoiY: 'Gợi ý tiêu chí thẩm định',
      thamDinhCham: 'Chấm điểm hồ sơ thẩm định',
      thamDinhCanTrongSo: 'Cân trọng số bộ tiêu chí',
      vanBanTomTat: 'Tóm tắt văn bản',
      vanBanSoanThao: 'Soạn thảo văn bản',
      vanBanDienTruong: 'Điền trường văn bản',
      vanBanPhanCong: 'Gợi ý phân công',
      vanBanPhanRa: 'Phân rã nhiệm vụ',
      vanBanDocPdfQuet: 'Đọc PDF quét',
      vanBanXemTruocMau: 'Xem trước mẫu văn bản',
    },
    phanRa: {
      tieuDe: 'Phân tích theo nhóm',
      moTa: 'Mỗi cách nhóm lấy 50 dòng nhiều token nhất.',
      nhom: 'Nhóm theo',
      bang: 'Phân tích token theo nhóm',
      theo_tenant: 'Tenant',
      theo_mo_hinh: 'Mô hình',
      theo_service: 'Dịch vụ',
      theo_tinh_nang: 'Tính năng',
      theo_don_vi: 'Đơn vị',
      theo_nguoi_dung: 'Người dùng',
      rongTieuDe: 'Không có dữ liệu trong kỳ',
      rongMoTa: 'Không bản ghi nào nằm trong khoảng đang chọn. Thử mở rộng khoảng thời gian.',
      cotKhoa: 'Nhóm',
      cotSoLuot: 'Lượt',
      cotDoTre: 'Độ trễ TB',
      doTreTrong: 'Không lượt nào ghi nhận độ trễ — khác với độ trễ 0 ms',
      cotTyLeLoi: 'Tỷ lệ lỗi',
      tyLeLoiMoTa: '{{loi}} lượt thất bại trên {{tong}} lượt',
      chuaCoGia: '{{so}} chưa có giá vốn',
      chuaCoGiaMoTa: 'Có lượt chưa tính được giá vốn vì thiếu dòng giá hoặc thiếu tỷ giá.',
      coCanhBao: '{{so}} cảnh báo',
      coCanhBaoMoTa: 'Có lượt mang cảnh báo quy đổi token — số token của dòng này chưa đủ tin cậy',
    },
    chuThichTenant: 'Số chính thức là thẻ "Token AI tháng này". Nhật ký này có thể chênh vài token do làm tròn.',
    cotFox: 'Token Fox',
    foxVao: 'Đầu vào',
    foxRa: 'Đầu ra',
    foxTong: 'Tổng',
    cotTokenThat: 'Token thật',
  },
} as const;
